"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** ExpandIcon */
var ExpandIcon = function ExpandIcon(props) {
  return _react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 18 18"
  }), _react.default.createElement(_Icon.Title, null, "expand"), _react.default.createElement(_Icon.Path, {
    d: "M15 3.708L10.76 7.96l-.708-.706L14.293 3H10V2h6v6h-1V3.708zM3 14.292l4.24-4.252.708.706L3.707 15H8v1H2v-6h1v4.292z",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "nonzero"
  }));
};

exports.ExpandIcon = ExpandIcon;
ExpandIcon.displayName = "ExpandIcon";
//# sourceMappingURL=ExpandIcon.js.map